
import { useState, useEffect } from 'react';
import { Singleton } from '../../../core/services/Singleton';
import { AdminService } from '../../../core/services/AdminService';
import { useDashboardStore } from '../../pages/hooks/useDashboardStore';
import { PrintJson } from './PrintJson';
interface Props {
    label?: string;
    code: number;
    value: number | undefined;
    onChange: Function;
    returnType?: "ID" | "Code" | "Object";
    style?: string;
}

export const SelectConstantsValue = ({
    label,
    code,
    value,
    onChange,
    returnType = "ID",
    style
}: Props) => {
    const { setLoading } = useDashboardStore();
    const service = new AdminService();
    const [lista, setLista] = useState<any[]>([]);
    const [selectedItem, setSelectedItem] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, [code]);

    useEffect(() => {
        if (selectedItem !== null) {
            switch (returnType) {
                case "ID":
                    onChange(selectedItem.DataBeanProperties.IDSuppConstantsValue);
                    break;
                case "Code":
                    onChange(selectedItem.DataBeanProperties.CodeID);
                    break;
                case "Object":
                    onChange(selectedItem.DataBeanProperties); // <- SOLO DataBeanProperties
                    break;
            }
        } else {
            onChange(null);
        }
    }, [selectedItem]);

    useEffect(() => {
        if (value && lista.length > 0) {
            const match = lista.find(item =>
                item.DataBeanProperties.IDSuppConstantsValue === value ||
                item.DataBeanProperties.CodeID === value
            );
            if (match) {
                setSelectedItem(match);
            }
        }
    }, [value])

    const getLista = () => {
        setLoading(true);
        service.getSuppConstantsValuesByCode(0, [code]).subscribe((resp: any) => {
            if (resp.DataBeanProperties.ObjectValue) {
                const list = resp.DataBeanProperties.ObjectValue['Code_' + code];
                setLista(list);
            }
            setLoading(false);
        });
    };

    const handleChange = (e) => {
        const selectedValue = e.target.value;
        const selected = lista.find(item =>
            (returnType === "ID" && item.DataBeanProperties.IDSuppConstantsValue.toString() === selectedValue) ||
            (returnType === "Code" && item.DataBeanProperties.CodeID.toString() === selectedValue) ||
            (returnType === "Object" && (
                item.DataBeanProperties.IDSuppConstantsValue.toString() === selectedValue ||
                item.DataBeanProperties.CodeID.toString() === selectedValue
            ))
        );
        setSelectedItem(selected || null);
    };

    return (
        <>
            <label>{label ?? ''}</label>
            <select
                className={`form-select ${style}`}
                value={
                    selectedItem
                        ? (returnType === "Code"
                            ? selectedItem.DataBeanProperties.CodeID
                            : selectedItem.DataBeanProperties.IDSuppConstantsValue)
                        : 0
                }
                id={`codeid-${code}`}
                onChange={handleChange}
            >
                <option value={0}>...</option>
                {lista.map((item: any, index: number) => (
                    <option
                        key={index}
                        value={returnType === "Code"
                            ? item.DataBeanProperties.CodeID
                            : item.DataBeanProperties.IDSuppConstantsValue}
                    >
                        {item.DataBeanProperties.Name}
                    </option>
                ))}
            </select>
        </>
    );
};
